import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { CreateEditSolarDialog } from 'src/app/shared/models/admin.model';

@Component({
  selector: 'app-create-edit-solar-form-dialog',
  templateUrl: './create-edit-solar-form-dialog.component.html',
  styleUrls: ['./create-edit-solar-form-dialog.component.scss']
})
export class CreateEditSolarFormDialogComponent implements OnInit {
  solarForm: UntypedFormGroup;
  isLoadingData: boolean;
  private unsubscribe: Subject<void> = new Subject<void>();
  linkAddress: string;
  file: any;
  modalHeaderTitle: string;
  isEdit: boolean;
  filePath: any;
  solarFormConentsList: any;
  isExtensionNotValid: boolean;

  constructor(private fb: UntypedFormBuilder,
              private snackBarService: SnackBarService,
              private adminRepository: AdminRepositoryService,
              private dialogRef: MatDialogRef<CreateEditSolarFormDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: CreateEditSolarDialog,) { }

  ngOnInit(): void {
    this.modalHeaderTitle = this.data.isEdit  === true ? 'Edit Form' : 'Add Form';
    this.isEdit = this.data.isEdit === true ? true : false;
    this.solarFormInitialize();
    if(this.data.isEdit){
      this.updateForm()
    }

    this.adminRepository.getSolarFormConents()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((solarFormConents) => {
        if (solarFormConents) {
          this.solarFormConentsList = solarFormConents;
        }
    });
  }

  formExistsValidation(value) {
   
    let result = this.solarFormConentsList.filter(user => user.formNumber == value);
    if(result.length > 0){
      this.form.setErrors({ inFormExists: true });
    } 
  }

  solarFormInitialize() {  
    if(this.data.isEdit){
      this.solarForm = this.fb.group({
        form:  this.fb.control('', [Validators.required]),
        name: this.fb.control('', [Validators.required]),
        category: this.fb.control('', [Validators.required]),
        description: this.fb.control(''),
        document: this.fb.control(''),
        isActive: this.fb.control(true)
      });
    } else { 
    this.solarForm = this.fb.group({
      form:  this.fb.control('', [Validators.required]),
      name: this.fb.control('', [Validators.required]),
      category: this.fb.control('', [Validators.required]),
      description: this.fb.control(''),
      document: this.fb.control('', [Validators.required]),
      isActive: this.fb.control(true)
    });
  }
  }

  onFileSelected(event) {
    this.file = event.target.files[0];
  }

  onSaveClick() {
    this.isLoadingData = true;
    let contentForm = this.getFormDetails();
    let formData: FormData = new FormData();
    if(!this.data.isEdit) {
    formData.append("file", this.file);
    }
    formData.append('formNumber', contentForm.formNumber);
    formData.append('formName', contentForm.formName);
    formData.append('category', contentForm.category);
    formData.append('description', contentForm.description);
    formData.append('isActive', contentForm.isActive);
    if(!this.data.isEdit) {
    this.adminRepository.saveSolarForm(formData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('Solar Form Info has been successfully added/updated');
          this.isLoadingData = false;
        }
      },(error) => {
        if (error.status == 400) { 
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }
        else {
          this.dialogRef.close(false);
          this.isLoadingData = false;
        }
      });
    } else {
      formData.append('formId',this.data.data.formId);
      formData.append("file", this.file == undefined ? this.data.data.filePath : this.file);
      this.adminRepository.updateSolarForm(formData)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        if (data) {
          this.dialogRef.close(true);
          this.snackBarService.showSuccess('Home Section Content has been successfully added/updated');
          this.isLoadingData = false;
        }
      }, err => {
        if (err.status == 405) {
          this.isExtensionNotValid = true;
          this.isLoadingData = false;
        }
        else if (err.status == 400) { 
          this.snackBarService.showError("Invalid input!");
          this.isLoadingData = false;
        }       
        else {
          this.dialogRef.close(false);
          this.isLoadingData = false;
          console.log(err);
        }
      });
    }
  }

  getFormDetails() {
    return {
        formNumber: this.form.value,
        formName: this.name.value,
        category: this.category.value,
        description: this.description.value,
        file: this.linkAddress,
        isActive: this.isEdit ? (this.isActive.value == true ? 'Yes' : 'No') : 'Yes'
    }
  }

  private updateForm(){
    this.form.patchValue(parseInt(this.data.data.formNumber));
    this.name.patchValue(this.data.data.formName);
    this.category.patchValue(this.data.data.category);
    this.description.patchValue(this.data.data.description == null ? '' : this.data.data.description);
    this.isActive.patchValue(this.data.data.isActive == 'No' ? false : true);
    this.filePath = this.data.data.filePath == null ? '' : this.data.data.filePath.split('SolarForms\\');
   // this.document.patchValue(this.filePath[1]);
 }

  onCancelClick() {
    this.dialogRef.close();
  }

  get form() {
    return this.solarForm.get('form') as UntypedFormControl;
  }

  get name() {
    return this.solarForm.get('name') as UntypedFormControl;
  }

  get category() {
    return this.solarForm.get('category') as UntypedFormControl;
  }

  get description() {
    return this.solarForm.get('description') as UntypedFormControl;
  }

  get document() {
    return this.solarForm.get('document') as UntypedFormControl;
  }

  get isActive() {
    return this.solarForm.get('isActive') as UntypedFormControl;
  }

}
